import { render, staticRenderFns } from "./RelatorioEquipe.vue?vue&type=template&id=aba78be0"
import script from "./RelatorioEquipe.vue?vue&type=script&lang=ts"
export * from "./RelatorioEquipe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports